


import SEOHead from '../../components/SEOHead';

import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Home() {
  const [isVisible, setIsVisible] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showTopImage, setShowTopImage] = useState(false);
  const [showCatchphrase, setShowCatchphrase] = useState(false);
  const [showCharacter, setShowCharacter] = useState(false);
  const [selectedStudio, setSelectedStudio] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    lastName: '',
    firstName: '',
    email: '',
    message: ''
  });

  useEffect(() => {
    // メインコピーのフェードイン
    const timer1 = setTimeout(() => {
      setIsVisible(true);
    }, 800);
    
    // 説明文のフェードイン（1秒遅延）
    const timer2 = setTimeout(() => {
      setShowDescription(true);
    }, 1800);

    // トップ画像のフェードイン
    const timer3 = setTimeout(() => {
      setShowTopImage(true);
    }, 300);

    // キャッチコピーのアニメーション
    const timer4 = setTimeout(() => {
      setShowCatchphrase(true);
    }, 1000);

    // 小人イラストのアニメーション（0.5秒ディレイ）
    const timer5 = setTimeout(() => {
      setShowCharacter(true);
    }, 1500);
    
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
    };
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    // バリデーション
    if (!formData.lastName.trim() || !formData.firstName.trim() || !formData.email.trim()) {
      alert('姓・名・メールアドレスは必須項目です。');
      return;
    }
    
    if (formData.message.length > 500) {
      alert('お問い合わせ内容は500文字以内で入力してください。');
      return;
    }

    // フォームデータを送信
    const form = new FormData();
    form.append('lastName', formData.lastName);
    form.append('firstName', formData.firstName);
    form.append('email', formData.email);
    form.append('message', formData.message);

    fetch('https://readdy.ai/api/form/d4a26l64v2qe61n4pgpg', {
      method: 'POST',
      body: form
    })
    .then(response => {
      if (response.ok) {
        alert('お問い合わせを送信いたしました。ありがとうございます。');
        setFormData({ lastName: '', firstName: '', email: '', message: '' });
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      alert('送信に失敗しました。もう一度お試しください。');
    });
  };

  const studios = [
    {
      name: 'Photo studio Bitte',
      address: '福岡県春日市若葉台東3-38',
      hours: '営業時間　予約必須',
      features: '駐車場有',
      mapQuery: '福岡県春日市若葉台東3-38'
    }
  ];

  const getMapUrl = (query: string) => {
    const encodedQuery = encodeURIComponent(query);
    return `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dOWTgHz-TK7VFC&q=${encodedQuery}&zoom=15`;
  };

  const handleStudioClick = (studio: any) => {
    setSelectedStudio(studio.mapQuery);
  };

  return (
    <>
      <SEOHead
        title="LiMU - 小さな「いま」を、永遠に残すアート | 3D手足アートブランド"
        description="LiMUは家族の大切な瞬間を美しく残す3D手足アートブランドです。赤ちゃんの小さな手足を立体的に残し、未来への手紙と共にお届けします。温もりと記憶を永遠に。"
        keywords="LiMU,3Dアート,手足アート,赤ちゃん,記念品,家族,思い出"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://limu-art.com'}/`}
      />
      
      <div className="min-h-screen bg-white">
        {/* ヘッダー */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100">
          <nav className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
            <div className="text-2xl font-bold text-[#1e2a1e]" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
              LiMU
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="#concept" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>コンセプト</a>
              <a href="#story" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>ストーリー</a>
              <a href="#flow" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>制作の流れ</a>
              <a href="#products" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>商品紹介</a>
              <a href="#voices" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>お客様の声</a>
              <a href="#contact" className="text-[#1e2a1e] hover:text-[#5a7d5a] transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>仮予約フォーム</a>
            </div>
            <button className="md:hidden text-[#1e2a1e]">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </nav>
        </header>

        {/* ヒーローセクション */}
        <section className="relative min-h-screen flex items-end justify-start overflow-hidden pt-16">
          <div 
            className="absolute inset-0 w-full"
            style={{
              aspectRatio: '16 / 12',
              maxHeight: '120vh'
            }}
          >
            <img 
              src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/06ca1f68f3d2943973e2bb7420b737f4.jpeg"
              alt="LiMU Hero"
              className="w-full h-full object-cover object-center"
            />
          </div>
          
          <div className="relative z-10 w-full px-6 md:px-12 pb-12 md:pb-16">
            {/* メインコピー(詩部分) */}
            <div 
              className={`transition-all duration-800 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <h1 
                className="text-2xl md:text-3xl lg:text-4xl xl:text-4xl font-light text-[#1e2a1e] leading-[1.6] mb-8 md:mb-12"
                style={{ 
                  fontFamily: 'Noto Serif JP, serif',
                  fontWeight: '300',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.15)',
                  textAlign: 'left'
                }}
              >
                こうだった<br />
                って笑える日がくるように。
              </h1>
            </div>

            {/* 説明文部分 */}
            <div 
              className={`transition-all duration-800 ease-out ${
                showDescription ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p 
                className="text-base md:text-lg lg:text-xl xl:text-xl text-[#1e2a1e] font-normal leading-[1.8] max-w-[500px]"
                style={{ 
                  fontFamily: 'Noto Serif JP, serif',
                  fontWeight: '400',
                  textShadow: '2px 2px 4px rgba(0,0,0,0.15)',
                  textAlign: 'left'
                }}
              >
                LiMUは、赤ちゃんの小さな手足を<br />
                3Dアートにして残すブランドです。<br />
                想いをかたちに、手紙を添えて。
              </p>
            </div>
          </div>
        </section>

        {/* コンセプトセクション */}
        <section id="concept" className="py-24 bg-[#f1f7f3]">
          <div className="max-w-6xl mx-auto px-6 text-center">
            <div className="flex items-center justify-center gap-4 mb-16 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                LiMUが大切にしていること
              </h2>
            </div>
            <div className="grid md:grid-cols-4 gap-12">
              <div className="space-y-6">
                <div className="w-20 h-20 mx-auto bg-[#e6f1ea] rounded-full flex items-center justify-center">
                  <i className="ri-hand-heart-line text-3xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                </div>
                <h3 className="text-xl font-medium text-[#1e2a1e]" style={{ fontFamily: 'Kiwi Maru, serif', fontSize: '22px' }}>
                  ためらいに寄り添う
                </h3>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '16px', lineHeight: '1.9' }}>
                  「残したい」と「ためらい」のあいだある気持ちを、そっと包み込むように。
                </p>
              </div>
              <div className="space-y-6">
                <div className="w-20 h-20 mx-auto bg-[#e6f1ea] rounded-full flex items-center justify-center">
                  <i className="ri-heart-line text-3xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                </div>
                <h3 className="text-xl font-medium text-[#1e2a1e]" style={{ fontFamily: 'Kiwi Maru, serif', fontSize: '22px' }}>
                  温もりを残す
                </h3>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '16px', lineHeight: '1.9' }}>
                  小さな手足の形だけでなく、その瞬間の温もりや記憶も一緒に残します。
                </p>
              </div>
              <div className="space-y-6">
                <div className="w-20 h-20 mx-auto bg-[#e6f1ea] rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-3xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                </div>
                <h3 className="text-xl font-medium text-[#1e2a1e]" style={{ fontFamily: 'Kiwi Maru, serif', fontSize: '22px' }}>
                  時を刻む
                </h3>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '16px', lineHeight: '1.9' }}>
                  今この瞬間は二度と戻らない。だからこそ、大切な「いま」を永遠に。
                </p>
              </div>
              <div className="space-y-6">
                <div className="w-20 h-20 mx-auto bg-[#e6f1ea] rounded-full flex items-center justify-center">
                  <i className="ri-gift-line text-3xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                </div>
                <h3 className="text-xl font-medium text-[#1e2a1e]" style={{ fontFamily: 'Kiwi Maru, serif', fontSize: '22px' }}>
                  未来への贈り物
                </h3>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '16px', lineHeight: '1.9' }}>
                  手紙と共に、未来の家族へ愛を届ける特別なアート作品です。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ブランドストーリー */}
        <section id="story" className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-16 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                ブランドへの想い
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="space-y-6 text-[#1e2a1e] leading-relaxed text-lg" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '17px', lineHeight: '1.9' }}>
                <p style={{ marginBottom: '0.9em' }}>
                  LiMUは、「欲しいけど、少し勇気がいる」<br />
                  そんな気持ちから生まれたブランドです。
                </p>
                <p style={{ marginBottom: '0.9em' }}>
                  手足の小さな形を残したい――<br />
                  その瞬間の温もりを閉じ込めることに、<br />
                  どこかためらいを感じる方もいます。
                </p>
                <p style={{ marginBottom: '0.9em' }}>
                  だからLiMUは、<br />
                  その「迷い」にそっと寄り添って、<br />
                  形だけでなく「記憶」や「やさしさ」まで<br />
                  作品にしたいと思いました。
                </p>
                <p style={{ marginBottom: '0.9em' }}>
                  飾ったとき、あの日の瞬間がそっと戻ってきます。<br />
                  家族の時間、優しく続いていきます。
                </p>
                <p className="font-medium" style={{ marginBottom: '0.9em' }}>
                  LiMUのライフキャスティングは、<br />
                  「残すこと」に少し勇気がいる人へ、<br />
                  そっと寄り添う温もりの記録です。
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {/* 左上：縦長・大 */}
                <div className="row-span-2">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/23301d027aa28cfe1e1ea7642710f3b0.jpeg"
                    alt="3D手足アート作品"
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                {/* 右上：横長・小 */}
                <div className="col-start-2 row-start-1">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/6c60dbf4ffeab9f4f3593fa6e7b9f353.jpeg"
                    alt="安心した型取り"
                    className="w-full h-48 object-cover rounded-lg"
                  />
                </div>
                {/* 右下：縦長・中 */}
                <div className="col-start-2 row-start-2 row-span-2">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/50025f107482fcfb6cc045e345b532a1.jpeg"
                    alt="心に残る撮影"
                    className="w-full h-full object-cover rounded-lg"
                  />
                </div>
                {/* 左下：横長・小 */}
                <div className="col-start-1 row-start-3">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/7960fc1277a704c505ba222e3d01da69.jpeg"
                    alt="未来への手紙"
                    className="w-full h-48 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 制作の流れ */}
        <section id="flow" className="py-24 bg-[#f1f7f3]">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-8 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] text-center relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                Flow
              </h2>
            </div>
            <p className="text-center text-[#4a5a4a] mb-16 text-xl" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.9' }}>
              ご注文からお届けまでの流れ
            </p>
            
            <div className="relative">
              <div className="grid md:grid-cols-5 gap-8 relative">
                {/* ステップ1 */}
                <div className="flex flex-col items-center text-center space-y-4 md:mt-0">
                  <div className="relative">
                    <div className="w-40 h-40 bg-[#e8f2ec] rounded-full flex items-center justify-center mb-4 relative">
                      <i className="ri-chat-check-line text-5xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] rounded-full flex items-center justify-center border-4 border-white">
                        <span className="text-xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>1</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                    ご相談・ご注文
                  </h3>
                  <p className="text-sm text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                    LINEまたはフォームからお問い合わせ。ご希望の仕様や納期を伺います。
                  </p>
                </div>

                {/* ステップ2 */}
                <div className="flex flex-col items-center text-center space-y-4 md:mt-20">
                  <div className="relative">
                    <div className="w-40 h-40 bg-[#e8f2ec] rounded-full flex items-center justify-center mb-4 relative">
                      <i className="ri-calendar-check-line text-5xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] rounded-full flex items-center justify-center border-4 border-white">
                        <span className="text-xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>2</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                    日程調整・ご予約
                  </h3>
                  <p className="text-sm text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                    提携スタジオの空き状況をご案内。ご家族の予定に合わせて予約を確定します。
                  </p>
                </div>

                {/* ステップ3 */}
                <div className="flex flex-col items-center text-center space-y-4 md:mt-0">
                  <div className="relative">
                    <div className="w-40 h-40 bg-[#e8f2ec] rounded-full flex items-center justify-center mb-4 relative">
                      <i className="ri-edit-line text-5xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] rounded-full flex items-center justify-center border-4 border-white">
                        <span className="text-xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>3</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                    型取り・制作
                  </h3>
                  <p className="text-sm text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                    提携スタジオで安心の型取り。工房で塗装・仕上げ・名入れを行います。
                  </p>
                </div>

                {/* ステップ4 */}
                <div className="flex flex-col items-center text-center space-y-4 md:mt-20">
                  <div className="relative">
                    <div className="w-40 h-40 bg-[#e8f2ec] rounded-full flex items-center justify-center mb-4 relative">
                      <i className="ri-box-3-line text-5xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] rounded-full flex items-center justify-center border-4 border-white">
                        <span className="text-xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>4</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                    検品・梱包
                  </h3>
                  <p className="text-sm text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                    品質チェック後、手紙と一緒にひらく喜びのボックスへ<br />
丁寧に梱包します。
                  </p>
                </div>

                {/* ステップ5 */}
                <div className="flex flex-col items-center text-center space-y-4 md:mt-0">
                  <div className="relative">
                    <div className="w-40 h-40 bg-[#e8f2ec] rounded-full flex items-center justify-center mb-4 relative">
                      <i className="ri-gift-line text-5xl text-[#5a7d5a]" style={{ strokeWidth: '1.5px' }}></i>
                      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#5a7d5a] rounded-full flex items-center justify-center border-4 border-white">
                        <span className="text-xl font-bold text-white" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>5</span>
                      </div>
                    </div>
                  </div>
                  <h3 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                    お届け
                  </h3>
                  <p className="text-sm text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                    手紙と一緒に、ひらく喜びのボックスでお届け。飾ってすぐ楽しめます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 商品紹介 */}
        <section id="products" className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-16 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] text-center relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                商品紹介
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-16 items-center mb-20">
              <div>
                <img 
                  src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/6730553a814a60e7987e75933316fd6a.jpeg"
                  alt="3D手足アート作品"
                  className="w-full rounded-2xl shadow-sm object-cover"
                  style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.08))' }}
                />
              </div>
              <div className="space-y-8">
                <h3 className="text-2xl font-normal text-[#1e2a1e]" style={{ fontFamily: 'Shippori Mincho B1, serif' }}>
                  3D手足アート
                </h3>
                <div 
                  className={`transition-all duration-800 ease-out ${
                    showCatchphrase ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                  }`}
                >
                  <p className="text-[#1e2a1e] leading-relaxed text-lg mb-6" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '17px', lineHeight: '1.9' }}>
                    いまの小さな一瞬を、未来の宝物に。
                  </p>
                </div>
                <p className="text-[#1e2a1e] leading-relaxed text-lg" style={{ fontFamily: 'Noto Sans JP, sans-serif', fontSize: '17px', lineHeight: '1.9' }}>
                  お子様の小さな手足を立体的に残す、特別なアート作品です。安全で高品質な素材を使用し、一つひとつ丁寧に制作いたします。
                </p>
                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-[#5a7d5a] text-xl" style={{ strokeWidth: '1.5px' }}></i>
                    <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>安心して触れられる素材</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-[#5a7d5a] text-xl" style={{ strokeWidth: '1.5px' }}></i>
                    <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>想いのこもった手仕事</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <div 
                      className={`transition-all duration-500 ease-out ${
                        showCharacter ? 'opacity-100' : 'opacity-0'
                      }`}
                    >
                      <i className="ri-check-line text-[#5a7d5a] text-xl" style={{ strokeWidth: '1.5px' }}></i>
                    </div>
                    <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>小人が見守る世界</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-check-line text-[#5a7d5a] text-xl" style={{ strokeWidth: '1.5px' }}></i>
                    <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>想いを届ける手紙</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center space-y-6">
                <img 
                  src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/c0f2152c24da3cb0cf78c20ce0ead786.jpeg"
                  alt="木製フレーム"
                  className="w-full h-64 object-cover rounded-xl"
                />
                <h4 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                  安心した型取り
                </h4>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  子ども対応のプロが、やさしい手つきで“いま”を形に。泣いてしまっても大丈夫、穏やかな時間の中で残します。
                </p>
              </div>
              <div className="text-center space-y-6">
                <img 
                  src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/4ae7c546f70d2e8903c7652e86e043c4.jpeg"
                  alt="手紙"
                  className="w-full h-64 object-cover rounded-xl"
                />
                <h4 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                  我が子へ未来の手紙
                </h4>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  20歳になった時、子供に渡してあげてください。"いま"の想いを未来へ。手紙が家族のぬくもりをそっとつなぎます。
                </p>
              </div>
              <div className="text-center space-y-6">
                <img 
                  src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/59cd9d70657580b620ab613d69f1d393.jpeg"
                  alt="高品質素材"
                  className="w-full h-64 object-cover rounded-xl"
                />
                <h4 className="text-lg font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                  心に残る撮影
                </h4>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  光の中で生まれる、家族の自然な笑顔。写真を見るたび、あの日のぬくもりがよみがえります。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* お客様の声 */}
        <section id="voices" className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-16 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] text-center relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                お客様の声
              </h2>
            </div>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-2xl border border-[#e6f1ea]">
                <div className="flex items-center space-x-4 mb-6">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/ac946d87155a97f200df50bda4784855.png"
                    alt="お客様"
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>J.N.さん(20代女性)</h4>
                    <p className="text-sm text-[#4a5a4a]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>生後6ヶ月のお子様</p>
                  </div>
                </div>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  小さな手足がこんなに美しく残せるなんて感動しました。毎日見るたびに、あの時の温もりを思い出します。
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl border border-[#e6f1ea]">
                <div className="flex items-center space-x-4 mb-6">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/2f035b82676b4289e20f571684c272d3.png"
                    alt="お客様"
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>M.S.さん(30代女性)</h4>
                    <p className="text-sm text-[#4a5a4a]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>1歳のお子様</p>
                  </div>
                </div>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  手紙と一緒にできるのが特別でした。将来、子どもが大きくなった時に一緒に読むのが楽しみです。
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl border border-[#e6f1ea]">
                <div className="flex items-center space-x-4 mb-6">
                  <img 
                    src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/2a8ef07bc123a07e268a131f7f22223b.png"
                    alt="お客様"
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h4 className="font-medium text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>M.I.(30代女性)</h4>
                    <p className="text-sm text-[#4a5a4a]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>新生児のお子様</p>
                  </div>
                </div>
                <p className="text-[#1e2a1e] leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.6' }}>
                  最初は"残すのが少し怖い"気持ちもありましたが、完成した作品を見て、その迷いが一瞬で消えました。今では、家族で一番大切にしている宝物です。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* お近くのフォトスタジオ */}
        <section id="studio" className="py-24 bg-white">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-8 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] text-center relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                Studio
              </h2>
            </div>
            <p className="text-center text-[#4a5a4a] mb-16 text-xl" style={{ fontFamily: 'Noto Sans JP, sans-serif', lineHeight: '1.9' }}>
              福岡県内で複数店舗をマップ表示<br />
            </p>
            
            <div className="grid md:grid-cols-2 gap-16 items-start">
              {/* 地図エリア */}
              <div className="bg-[#f5f5f5] rounded-2xl overflow-hidden h-96">
                <iframe
                  src={selectedStudio ? getMapUrl(selectedStudio) : "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d212270.5631094339!2d130.24782842968748!3d33.606762!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x354191606a4f7e01%3A0x2b7a4e6e4b4e4e4e!2z56aP5bKh5biC!5e0!3m2!1sja!2sjp!4v1234567890123!5m2!1sja!2sjp"}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="福岡県内のLiMU提携スタジオ"
                />
              </div>

              {/* スタジオ情報 */}
              <div className="space-y-8">
                {studios.map((studio, index) => (
                  <div 
                    key={index}
                    onClick={() => handleStudioClick(studio)}
                    className="bg-[#f1f7f3] rounded-2xl p-8 border border-[#e6f1ea] cursor-pointer hover:bg-[#e6f1ea] transition-colors"
                  >
                    <h3 className="text-xl font-medium text-[#1e2a1e] mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '0.2%' }}>
                      {studio.name}
                    </h3>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <i className="ri-map-pin-line text-[#1e2a1e]" style={{ strokeWidth: '1.5px' }}></i>
                        <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>{studio.address}</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-time-line text-[#1e2a1e]" style={{ strokeWidth: '1.5px' }}></i>
                        <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>{studio.hours}</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className={`${studio.features.includes('093-') ? 'ri-phone-line' : studio.features.includes('駐車場') ? 'ri-car-line' : studio.features.includes('ベビー') ? 'ri-home-line' : 'ri-calendar-line'} text-[#1e2a1e]`} style={{ strokeWidth: '1.5px' }}></i>
                        <span className="text-[#1e2a1e]" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>{studio.features}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* お問い合わせ */}
        <section id="contact" className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6">
            <div className="flex items-center justify-center gap-4 mb-4 relative">
              <img 
                src="https://static.readdy.ai/image/7c19c1fe65725eb3725ae09e3bf3d949/48efe11410a83c317abe6f91d21cb41e.png"
                alt="装飾"
                className="w-24 h-24 object-contain absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 opacity-10"
              />
              <h2 className="text-3xl md:text-4xl font-normal text-[#1e2a1e] text-center relative z-10" style={{ fontFamily: 'Shippori Mincho B1, serif', lineHeight: '1.4' }}>
                仮予約フォーム
              </h2>
            </div>
            <p className="text-center text-[#4a5a4a] text-sm mb-16" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
              ※この時点では料金は発生しません<br />
              仮予約は日程の確保ではなく、実施を前向きにご検討いただくためのご登録です。<br />
              内容を確認の上、1〜3日以内に極力ご連絡いたします。
            </p>
            <div className="max-w-2xl mx-auto">
              <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="lastName" className="block text-[#1e2a1e] font-medium mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                      姓 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-[#e6f1ea] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5a7d5a] text-sm"
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                      placeholder="山田"
                    />
                  </div>
                  <div>
                    <label htmlFor="firstName" className="block text-[#1e2a1e] font-medium mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                      名 <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      required
                      className="w-full px-4 py-3 border border-[#e6f1ea] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5a7d5a] text-sm"
                      style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                      placeholder="太郎"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="email" className="block text-[#1e2a1e] font-medium mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    メールアドレス <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-[#e6f1ea] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5a7d5a] text-sm"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    placeholder="example@email.com"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-[#1e2a1e] font-medium mb-2" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    お問い合わせ内容
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    maxLength={500}
                    rows={6}
                    className="w-full px-4 py-3 border border-[#e6f1ea] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#5a7d5a] text-sm resize-none"
                    style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                    placeholder="お問い合わせ内容をご記入ください（500文字以内）"
                  />
                  <p className="text-sm text-[#4a5a4a] mt-1" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                    {formData.message.length}/500文字
                  </p>
                </div>
                <button
                  type="submit"
                  className="w-full bg-[#e6f1ea] text-[#1e2a1e] py-4 rounded-xl font-medium hover:bg-[#5a7d5a] hover:text-white transition-all duration-300 whitespace-nowrap"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif', letterSpacing: '1%' }}
                >
                  送信する
                </button>
              </form>
            </div>
          </div>
        </section>

        {/* フッター */}
        <footer className="bg-[#1e2a1e] text-white py-16">
          <div className="max-w-6xl mx-auto px-6">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ブランド</h4>
                <ul className="space-y-2 text-white/80">
                  <li><a href="#concept" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>コンセプト</a></li>
                  <li><a href="#story" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>ブランドストーリー</a></li>
                  <li><a href="#voices" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>お客様の声</a></li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>サービス</h4>
                <ul className="space-y-2 text-white/80">
                  <li><a href="#products" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>商品紹介</a></li>
                  <li><a href="#flow" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>制作の流れ</a></li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>サポート</h4>
                <ul className="space-y-2 text-white/80">
                  <li><a href="#contact" className="hover:text-white transition-colors cursor-pointer" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>仮予約フォーム</a></li>
                </ul>
              </div>
            </div>
            <div className="border-t border-white/20 pt-8">
              <h4 className="font-medium mb-4" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>コピーライト</h4>
              <div className="flex flex-col md:flex-row justify-between items-center">
                <p className="text-white/60 text-sm" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  © 2024 LiMU. All rights reserved.
                </p>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer mt-4 md:mt-0"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

